import { create } from "zustand";
import CommunicationManager from "../Helper/CommunicationManager";

// The expand/collapse window state is owned by the host SDK (it sizes the
// iframe container and remembers the choice). The SDK reports it via
// `widget-size-update`; SDKs without the feature never do, so the button stays
// hidden for them. Kept free of other store imports so it stays unit-testable.
interface WidgetSizeState {
  expandable: boolean;
  expanded: boolean;
  applySizeUpdate: (data: any) => void;
  setExpanded: (expanded: boolean) => void;
}

export const useWidgetSizeStore = create<WidgetSizeState>()((set) => ({
  expandable: false,
  expanded: false,
  applySizeUpdate: (data) => {
    set({
      expandable: data?.expandable === true,
      expanded: data?.expandable === true && data?.expanded === true,
    });
  },
  setExpanded: (expanded) => {
    // Optimistic: the SDK answers with the real state (widget-size-update).
    set({ expanded });
    CommunicationManager.getInstance().sendMessage({
      name: "set-widget-expanded",
      data: { expanded },
    });
  },
}));
